import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import AppAuthed from './AppAuthed'

const stateToProps = ({ auth }) => ({
  isLoggedIn: !!(auth.token && auth.user && auth.user.id),
  allConfirmed: !!(auth.allConfirmed || auth.adminUserId),
})

const dispatchToProps = {
  goLogin: () => replace('/login'),
  goSettings: () => replace('/dashboard/settings'),
}

export default connect(stateToProps, dispatchToProps)(AppAuthed)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/pages/AppAuthed/AppAuthed.container.js